import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useViewMode } from '../../contexts/ViewModeContext';
import { LEARN_HOME } from '../../contexts/viewMode.utils';

/**
 * Smart entry point for `/`. Every post-auth flow (login, signup, workspace
 * select, Google SSO) lands here; we then route by capability — staff to their
 * first accessible management page, everyone else to Learning. This is the
 * "staff land in Manage after login" rule: the landing is deliberately NOT
 * driven by the persisted toggle preference (which only governs the sidebar on
 * shared routes within a session and is restored on reload), so a stale "learn"
 * preference can never strand a manager on the Learning surface at login.
 */
const HomeRedirect: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const { canManage, manageHome } = useViewMode();

  // Wait for the session to hydrate before deciding where to send the member.
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background-primary">
        <div className="spinner spinner-lg text-primary-600 dark:text-primary-350" aria-label="Loading..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  return <Navigate to={canManage ? manageHome : LEARN_HOME} replace />;
};

export default HomeRedirect;
